var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgThongBao = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 28.5714C0.333496 12.7919 13.1254 0 28.9049 0H71.7621C87.5416 0 100.333 12.7919 100.333 28.5714V71.4286C100.333 87.2081 87.5416 100 71.7621 100H28.9049C13.1254 100 0.333496 87.2081 0.333496 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_898)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3886 25.6521C41.5225 25.6521 34.3172 32.8575 34.3172 41.7235V49.4646C34.3172 51.0985 33.6208 53.5896 32.7904 54.9825L29.71 60.0985C27.8083 63.2592 29.1208 66.7682 32.6029 67.9467C44.1475 71.8039 56.6029 71.8039 68.1475 67.9467C71.3886 66.8753 72.8082 63.045 71.0404 60.0985L67.96 54.9825C67.1565 53.5896 66.46 51.0985 66.46 49.4646V41.7235C66.46 32.8842 59.2279 25.6521 50.3886 25.6521Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3424 26.4282C54.512 26.1872 53.6549 25.9997 52.7709 25.8925C50.1995 25.5711 47.7352 25.7586 45.4316 26.4282C46.2084 24.4461 48.137 23.0532 50.387 23.0532C52.637 23.0532 54.5656 24.4461 55.3424 26.4282Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4215 68.9106C58.4215 73.3303 54.8055 76.9464 50.3858 76.9464C48.1894 76.9464 46.1537 76.0356 44.7072 74.5892C43.2608 73.1428 42.3501 71.1071 42.3501 68.9106",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_898",
    x1: 50.3335,
    y1: 0,
    x2: 50.3335,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ABAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B7DA"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThongBao, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ThongBao.2af86678.svg";
export { ForwardRef as ReactComponent };